<template>
<div class="chapter">
<div class="inner_page">
<p class="ChapTitle1"><a id="HLD4"></a>Block Index</p>
<p class="h1">8˝ × 8˝ Blocks</p>
<p class="fcap">The blocks in this section will measure 8½˝ × 8½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 8˝ × 8˝.</p>
<p class="fig"><img alt="" src="images/pg7_1.jpg"/></p>
<p class="fcap"><span href="#/26_chapter22#HLD24" title="Link target outside of Sample">Apartment</span></p>
<p class="fig"><img alt="" src="images/pg7_2.jpg"/></p>
<p class="fcap"><span href="#/31_chapter27#HLD29" title="Link target outside of Sample">Clock Tower</span></p>
<p class="fig"><img alt="" src="images/pg7_3.jpg"/></p>
<p class="fcap"><span href="#/10_chapter06#HLD8" title="Link target outside of Sample">Crosswalk</span></p>
<p class="fig"><img alt="" src="images/pg7_4.jpg"/></p>
<p class="fcap"><a href="#/09_chapter05#HLD7">Donut Shop</a></p>
<p class="fig"><img alt="" src="images/pg7_5.jpg"/></p>
<p class="fcap"><span href="#/25_chapter21#HLD23" title="Link target outside of Sample">Drawbridge</span></p>
<p class="fig"><img alt="" src="images/pg7_6.jpg"/></p>
<p class="fcap"><span href="#/21_chapter17#HLD19" title="Link target outside of Sample">Duplex</span></p>
<p class="fig"><img alt="" src="images/pg7_7.jpg"/></p>
<p class="fcap"><span href="#/19_chapter15#HLD17" title="Link target outside of Sample">Elevator</span></p>
<p class="fig"><img alt="" src="images/pg7_8.jpg"/></p>
<p class="fcap"><span href="#/16_chapter12#HLD14" title="Link target outside of Sample">Favorite Sweater</span></p>
<p class="fig"><img alt="" src="images/pg7_9.jpg"/></p>
<p class="fcap"><span href="#/18_chapter14#HLD16" title="Link target outside of Sample">Fence</span></p>
<p class="fig"><img alt="" src="images/pg7_10.jpg"/></p>
<p class="fcap"><span href="#/30_chapter26#HLD28" title="Link target outside of Sample">Food Truck</span></p>
<p class="fig"><img alt="" src="images/pg7_11.jpg"/></p>
<p class="fcap"><a href="#/08_chapter04#HLD6">Forest Park</a></p>
<p class="fig"><img alt="" src="images/pg7_12.jpg"/></p>
<p class="fcap"><span href="#/11_chapter07#HLD9" title="Link target outside of Sample">Intercom</span></p>
<p class="fig"><img alt="" src="images/pg7_13.jpg"/></p>
<p class="fcap"><span href="#/12_chapter08#HLD10" title="Link target outside of Sample">Intersection</span></p>
<p class="fig"><img alt="" src="images/pg7_14.jpg"/></p>
<p class="fcap"><span href="#/23_chapter19#HLD21" title="Link target outside of Sample">Library</span></p>
<p class="fig"><img alt="" src="images/pg7_15.jpg"/></p>
<p class="fcap"><span href="#/32_chapter28#HLD30" title="Link target outside of Sample">Lobby</span></p>
<p class="fig"><img alt="" src="images/pg7_16.jpg"/></p>
<p class="fcap"><span href="#/15_chapter11#HLD13" title="Link target outside of Sample">Mini Storage</span></p>
<p class="fig"><img alt="" src="images/pg7_17.jpg"/></p>
<p class="fcap"><span href="#/28_chapter24#HLD26" title="Link target outside of Sample">Mixed Use</span></p>
<p class="fig"><img alt="" src="images/pg7_18.jpg"/></p>
<p class="fcap"><span href="#/20_chapter16#HLD18" title="Link target outside of Sample">Museum</span></p>
<p class="fig"><img alt="" src="images/pg7_19.jpg"/></p>
<p class="fcap"><span href="#/14_chapter10#HLD12" title="Link target outside of Sample">Porch</span></p>
<p class="fig"><img alt="" src="images/pg7_20.jpg"/></p>
<p class="fcap"><span href="#/27_chapter23#HLD25" title="Link target outside of Sample">River Walk</span></p>
<p class="fig"><img alt="" src="images/pg7_21.jpg"/></p>
<p class="fcap"><span href="#/29_chapter25#HLD27" title="Link target outside of Sample">Roadblock</span></p>
<p class="fig"><img alt="" src="images/pg7_22.jpg"/></p>
<p class="fcap"><span href="#/22_chapter18#HLD20" title="Link target outside of Sample">Spotlight</span></p>
<p class="fig"><img alt="" src="images/pg7_23.jpg"/></p>
<p class="fcap"><span href="#/24_chapter20#HLD22" title="Link target outside of Sample">Streetlight</span></p>
<p class="fig"><img alt="" src="images/pg7_24.jpg"/></p>
<p class="fcap"><span href="#/17_chapter13#HLD15" title="Link target outside of Sample">Sushi</span></p>
<p class="fig"><img alt="" src="images/pg7_25.jpg"/></p>
<p class="fcap"><span href="#/13_chapter09#HLD11" title="Link target outside of Sample">Transit Center</span></p>
<p class="h1">5˝ × 8˝ Blocks</p>
<p class="fcap">The blocks in this section will measure 5½˝ × 8½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 5˝ × 8˝.</p>
<p class="fig"><img alt="" src="images/pg8_1.jpg"/></p>
<p class="fcap"><span href="#/56_chapter52#HLD56" title="Link target outside of Sample">Airport</span></p>
<p class="fig"><img alt="" src="images/pg8_2.jpg"/></p>
<p class="fcap"><span href="#/49_chapter45#HLD49" title="Link target outside of Sample">Bowling Alley</span></p>
<p class="fig"><img alt="" src="images/pg8_3.jpg"/></p>
<p class="fcap"><span href="#/39_chapter35#HLD39" title="Link target outside of Sample">Emergency Exit</span></p>
<p class="fig"><img alt="" src="images/pg8_4.jpg"/></p>
<p class="fcap"><span href="#/55_chapter51#HLD55" title="Link target outside of Sample">Fortune Cookies</span></p>
<p class="fig"><img alt="" src="images/pg8_5.jpg"/></p>
<p class="fcap"><span href="#/34_chapter30#HLD34" title="Link target outside of Sample">Half Sandwich</span></p>
<p class="fig"><img alt="" src="images/pg8_6.jpg"/></p>
<p class="fcap"><span href="#/40_chapter36#HLD40" title="Link target outside of Sample">House Plant</span></p>
<p class="fig"><img alt="" src="images/pg8_7.jpg"/></p>
<p class="fcap"><span href="#/50_chapter46#HLD50" title="Link target outside of Sample">Karaoke</span></p>
<p class="fig"><img alt="" src="images/pg8_8.jpg"/></p>
<p class="fcap"><span href="#/44_chapter40#HLD44" title="Link target outside of Sample">Kiosk</span></p>
<p class="fig"><img alt="" src="images/pg8_9.jpg"/></p>
<p class="fcap"><span href="#/43_chapter39#HLD43" title="Link target outside of Sample">Magazine Rack</span></p>
<p class="fig"><img alt="" src="images/pg8_10.jpg"/></p>
<p class="fcap"><span href="#/42_chapter38#HLD42" title="Link target outside of Sample">Meow</span></p>
<p class="fig"><img alt="" src="images/pg8_11.jpg"/></p>
<p class="fcap"><span href="#/36_chapter32#HLD36" title="Link target outside of Sample">Onramp</span></p>
<p class="fig"><img alt="" src="images/pg8_12.jpg"/></p>
<p class="fcap"><span href="#/33_chapter29#HLD33" title="Link target outside of Sample">Parking Garage</span></p>
<p class="fig"><img alt="" src="images/pg8_13.jpg"/></p>
<p class="fcap"><span href="#/45_chapter41#HLD45" title="Link target outside of Sample">Parking Meters</span></p>
<p class="fig"><img alt="" src="images/pg8_14.jpg"/></p>
<p class="fcap"><span href="#/37_chapter33#HLD37" title="Link target outside of Sample">Planter Box</span></p>
<p class="fig"><img alt="" src="images/pg8_15.jpg"/></p>
<p class="fcap"><span href="#/52_chapter48#HLD52" title="Link target outside of Sample">Raindrops</span></p>
<p class="fig"><img alt="" src="images/pg8_16.jpg"/></p>
<p class="fcap"><span href="#/35_chapter31#HLD35" title="Link target outside of Sample">Rec Center</span></p>
<p class="fig"><img alt="" src="images/pg8_17.jpg"/></p>
<p class="fcap"><span href="#/47_chapter43#HLD47" title="Link target outside of Sample">Rose Garden</span></p>
<p class="fig"><img alt="" src="images/pg8_18.jpg"/></p>
<p class="fcap"><span href="#/38_chapter34#HLD38" title="Link target outside of Sample">Sequins</span></p>
<p class="fig"><img alt="" src="images/pg8_19.jpg"/></p>
<p class="fcap"><span href="#/54_chapter50#HLD54" title="Link target outside of Sample">Sidewalk</span></p>
<p class="fig"><img alt="" src="images/pg8_20.jpg"/></p>
<p class="fcap"><span href="#/57_chapter53#HLD57" title="Link target outside of Sample">Skyline</span></p>
<p class="fig"><img alt="" src="images/pg8_21.jpg"/></p>
<p class="fcap"><span href="#/53_chapter49#HLD53" title="Link target outside of Sample">Stripey Socks</span></p>
<p class="fig"><img alt="" src="images/pg8_22.jpg"/></p>
<p class="fcap"><span href="#/48_chapter44#HLD48" title="Link target outside of Sample">Supermarket</span></p>
<p class="fig"><img alt="" src="images/pg8_23.jpg"/></p>
<p class="fcap"><span href="#/51_chapter47#HLD51" title="Link target outside of Sample">Traffic Cones</span></p>
<p class="fig"><img alt="" src="images/pg8_24.jpg"/></p>
<p class="fcap"><span href="#/46_chapter42#HLD46" title="Link target outside of Sample">Turnstile</span></p>
<p class="fig"><img alt="" src="images/pg8_25.jpg"/></p>
<p class="fcap"><span href="#/41_chapter37#HLD41" title="Link target outside of Sample">Waterfront</span></p>
<p class="h1">5˝ × 14˝ Blocks</p>
<p class="fcap">The blocks in this section will measure 5½˝ × 14½˝ including a ¼˝ seam allowance on each side. Once they are sewn into a project, the finished blocks will measure 5˝ × 14˝.</p>
<p class="fig"><img alt="" src="images/pg9_1.jpg"/></p>
<p class="fcap"><span href="#/70_chapter66#HLD75" title="Link target outside of Sample">Auditorium</span></p>
<p class="fig"><img alt="" src="images/pg9_2.jpg"/></p>
<p class="fcap"><span href="#/78_chapter74#HLD83" title="Link target outside of Sample">Balcony</span></p>
<p class="fig"><img alt="" src="images/pg9_3.jpg"/></p>
<p class="fcap"><span href="#/68_chapter64#HLD73" title="Link target outside of Sample">Bookstore</span></p>
<p class="fig"><img alt="" src="images/pg9_4.jpg"/></p>
<p class="fcap"><span href="#/60_chapter56#HLD65" title="Link target outside of Sample">Brewery</span></p>
<p class="fig"><img alt="" src="images/pg9_5.jpg"/></p>
<p class="fcap"><span href="#/61_chapter57#HLD66" title="Link target outside of Sample">Carpool</span></p>
<p class="fig"><img alt="" src="images/pg9_6.jpg"/></p>
<p class="fcap"><span href="#/58_chapter54#HLD63" title="Link target outside of Sample">City Hall</span></p>
<p class="fig"><img alt="" src="images/pg9_7.jpg"/></p>
<p class="fcap"><span href="#/64_chapter60#HLD69" title="Link target outside of Sample">Coffee Shop</span></p>
<p class="fig"><img alt="" src="images/pg9_8.jpg"/></p>
<p class="fcap"><span href="#/73_chapter69#HLD78" title="Link target outside of Sample">Cornerstone</span></p>
<p class="fig"><img alt="" src="images/pg9_9.jpg"/></p>
<p class="fcap"><span href="#/76_chapter72#HLD81" title="Link target outside of Sample">Corrugated Cardboard</span></p>
<p class="fig"><img alt="" src="images/pg9_10.jpg"/></p>
<p class="fcap"><span href="#/82_chapter78#HLD87" title="Link target outside of Sample">Do Not Enter</span></p>
<p class="fig"><img alt="" src="images/pg9_11.jpg"/></p>
<p class="fcap"><span href="#/62_chapter58#HLD67" title="Link target outside of Sample">Dog Park</span></p>
<p class="fig"><img alt="" src="images/pg9_12.jpg"/></p>
<p class="fcap"><span href="#/63_chapter59#HLD68" title="Link target outside of Sample">Escalator</span></p>
<p class="fig"><img alt="" src="images/pg9_13.jpg"/></p>
<p class="fcap"><span href="#/65_chapter61#HLD70" title="Link target outside of Sample">Haircut</span></p>
<p class="fig"><img alt="" src="images/pg9_14.jpg"/></p>
<p class="fcap"><span href="#/81_chapter77#HLD86" title="Link target outside of Sample">Laundromat</span></p>
<p class="fig"><img alt="" src="images/pg9_15.jpg"/></p>
<p class="fcap"><span href="#/69_chapter65#HLD74" title="Link target outside of Sample">Look Both Ways</span></p>
<p class="fig"><img alt="" src="images/pg9_16.jpg"/></p>
<p class="fcap"><span href="#/71_chapter67#HLD76" title="Link target outside of Sample">Post Office Box</span></p>
<p class="fig"><img alt="" src="images/pg9_17.jpg"/></p>
<p class="fcap"><span href="#/79_chapter75#HLD84" title="Link target outside of Sample">Puddles</span></p>
<p class="fig"><img alt="" src="images/pg9_18.jpg"/></p>
<p class="fcap"><span href="#/75_chapter71#HLD80" title="Link target outside of Sample">Restaurant</span></p>
<p class="fig"><img alt="" src="images/pg9_19.jpg"/></p>
<p class="fcap"><span href="#/66_chapter62#HLD71" title="Link target outside of Sample">Skylight</span></p>
<p class="fig"><img alt="" src="images/pg9_20.jpg"/></p>
<p class="fcap"><span href="#/74_chapter70#HLD79" title="Link target outside of Sample">Stadium</span></p>
<p class="fig"><img alt="" src="images/pg9_21.jpg"/></p>
<p class="fcap"><span href="#/67_chapter63#HLD72" title="Link target outside of Sample">Storefront</span></p>
<p class="fig"><img alt="" src="images/pg9_22.jpg"/></p>
<p class="fcap"><span href="#/77_chapter73#HLD82" title="Link target outside of Sample">Tiki Bar</span></p>
<p class="fig"><img alt="" src="images/pg9_23.jpg"/></p>
<p class="fcap"><span href="#/80_chapter76#HLD85" title="Link target outside of Sample">Tow-Away Zone</span></p>
<p class="fig"><img alt="" src="images/pg9_24.jpg"/></p>
<p class="fcap"><span href="#/72_chapter68#HLD77" title="Link target outside of Sample">Window Washer</span></p>
<p class="fig"><img alt="" src="images/pg9_25.jpg"/></p>
<p class="fcap"><span href="#/59_chapter55#HLD64" title="Link target outside of Sample">Zoo Train</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_chapter02.vue?789d6827